import { DATA_TYPES, DELIMINATOR } from "../constants";
import { argMax } from "../helpers/DataHelpers";
import { formatNumber } from "../helpers/FormatNumber";
import Dataset from "./Dataset";

export function makePredictionsAsString(
	X: number[][],
	trainData: Dataset,
	valueToPredict: string,
	models: any[]
) {
	let outputStr: string[];
	const outputType = trainData.getColumn(valueToPredict).columnType;
	if (outputType === DATA_TYPES.categorical) {
		const probs = makePredictionsAsProbs(X, models);
		const classes = probs.map((prob) => argMax(prob));
		const col = trainData.getColumn(valueToPredict);
		outputStr = classes.map(
			(val, index) =>
				col.getClassByIndex(val) + DELIMINATOR + probs[index][val]
		);
	} else {
		let output = makePredictions(X, trainData, valueToPredict, models);
		outputStr = output.map((val) => formatNumber(val));
		outputStr = outputStr.map((val) => val.replaceAll(",", ""));
	}
	return outputStr;
}
export function makePredictionsAsProbs(X: number[][], models: any[]) {
	const model = models[0]; // TODO: choose average output instead of best model
	let y = model.predictProbs(X) as number[][];
	return y;
}

export function makePredictions(
	X: number[][],
	trainData: Dataset,
	valueToPredict: string,
	models?: any[]
) {
	// Gather data from state
	const model = models[0]; // TODO: choose average output instead of best model
	let y = model.predict(X) as number[];
	let yCol = trainData.getColumn(valueToPredict);
	const output = Dataset.deNormalize(y, yCol.colStats);
	return output;
}
